import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import IncidentTypesSection from './components/IncidentTypesSection';
import WhatEngineersLearnSection from './components/WhatEngineersLearnSection';
import ScoringSection from './components/ScoringSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-bg-base font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <HowItWorks />
        <IncidentTypesSection />
        <WhatEngineersLearnSection />
        <ScoringSection />
        <FaqSection />
        <CtaSection />
      </main>
      <footer className="border-t border-border-subtle bg-bg-surface py-8">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/7a396de9d4a51ca3342f9bdb460bfa21/428ecad6dc888347ec85a95455290815.png"
              alt="ExplainError Daily"
              className="w-6 h-6 object-contain"
            />
            <span className="text-sm text-text-muted font-mono">
              Explain<span className="text-accent">Error</span> Daily
            </span>
          </div>
          <p className="text-xs text-text-muted">
            © 2026 ExplainError Daily. Built for engineers who work close to production.
          </p>
        </div>
      </footer>
    </div>
  );
}